<div class="row-title-container" [ngClass]="rowLabel | camelToKebab" fxLayout="column" fxLayoutAlign="center start"
     [class.pointer]="['damageRate'].includes(rowLabel)"
     (mouseenter)="['damageRate'].includes(rowLabel) && tooltip?.show()"
     (mouseleave)="['damageRate'].includes(rowLabel) && tooltip?.hide()">
                    <span>
                        {{ 'i18n_af_labelClassificationTableRow#' + rowLabel + (participantRole ? '#' + participantRole : '') | translate }}
                        @if (['damageRate'].includes(rowLabel)) {
                            <ui-kit-svg #tooltip="matTooltip"
                                        [matTooltip]="'i18n_af_tooltipClassificationTableRow#' + rowLabel | translate"
                                        matTooltipClass="pre-line"
                                        class="i-16 c-secondary-red-800" name="ic_help"/>
                        }
                    </span>
    @if (form) {
        <form [formGroup]="form" fxLayout="row" fxLayoutAlign="start start" class="mt-8 mw-90">
            <af-dictionary-selector dictionaryName="currency"
                                    class="w-100"
                                    [showCode]="true"
                                    [control]="form.controls.currency"
                                    [predefinedValue]="KZT_CURRENCY_CODE"/>
        </form>
    }
</div>
